







import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseTooltip from '@/components/BaseTooltip.vue'

@Component<InfoTooltip>({
    components: {
        BaseTooltip,
        FontAwesomeIcon
    }
})
export default class InfoTooltip extends Vue {}
